import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, Typography, MenuItem, Table, TableBody, TableRow, TableCell, TableHead, Icon, IconButton } from '@material-ui/core';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    intro: {
        color: '#ffffff'
    },
    card: {
        width: '100%',
        maxWidth: 400
    }
});

class AuthStudentTab extends Component {

    constructor(props) {
        super(props);
    }

    getCourseTable = (display, courses, student_id) => {
        if (!display) { return null }

        const currentCourseRows = courses.map(c => {
            return (
                <TableRow key={c.company_calendar_course_id}>
                    <TableCell>{c.CourseName}</TableCell>
                    <TableCell>
                        <IconButton
                            onClick={() => this.props.history.push(`/gradebook/student/event_list/${c.company_calendar_course_id}/${student_id}`)}
                        >
                            <Icon>book</Icon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })

        const tableBase =
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Course</TableCell>
                        <TableCell>To Gradebook</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentCourseRows}
                </TableBody>
            </Table>

        return tableBase
    }

    render() {
        const { classes, currentAuth } = this.props;
        const student = currentAuth.roles.filter(r => r.RoleName === 'Student')[0];

        const currentCourses = student.link_info.ActiveCourses.filter(c => c.finished === 0);
        const finishedCourses = student.link_info.ActiveCourses.filter(c => c.finished === 1);

        return (
            <div>
                <div style={{ paddingBottom: '20px' }}>
                    <Typography variant="h5"> {currentCourses.length > 0 ? 'Current Courses' : 'No Current Courses'} </Typography>
                    {this.getCourseTable(currentCourses.length > 0, currentCourses, student.link_id)}
                </div>
                <div>
                    <Typography variant="h5"> {finishedCourses.length > 0 ? 'Finished Courses' : 'No Finished Courses'} </Typography>
                    {this.getCourseTable(finishedCourses.length > 0, finishedCourses, student.link_id)}
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthStudentTab)));


// WEBPACK FOOTER //
// src/main/content/auth/AuthStudentTab.js